export enum AutomationEvent {
  PAYMENT_PAID = 'PAYMENT_PAID',
  PAYMENT_CREATED = 'PAYMENT_CREATED',
  CONVERSATION_CREATED = 'CONVERSATION_CREATED',
  CONVERSATION_RESOLVED = 'CONVERSATION_RESOLVED',
  MESSAGE_SENT = 'MESSAGE_SENT',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED'
}